export default "__VITE_ASSET__BOM$bMkj__"